import * as ActionTypes from '../../actions/allActions'

const signin = (state = { canSubmit: false }, action) => {
	switch (action.type) {
		case ActionTypes.SIGNIN_METACHANGE:
			return { ...state, ...action.changes }
		default:
			return state
	}
}

export default signin


// WEBPACK FOOTER //
// ./src/reducers/metadata/signin.js